import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ItemProfileWebService } from './spring/item-profile.web-service';
import { ItemResourceWebService } from './spring/item-resource.web-service';

@NgModule()
export class NgxHalWebServicesModule {
  public static forRoot(): ModuleWithProviders<NgxHalWebServicesModule> {
    return {
      ngModule: NgxHalWebServicesModule,
      providers: [
        {
          provide: ItemProfileWebService,
          useFactory: (httpClient: HttpClient) => new ItemProfileWebService(httpClient),
          deps: [HttpClient],
        },
        {
          provide: ItemResourceWebService,
          useFactory: (httpClient: HttpClient) => new ItemResourceWebService(httpClient),
          deps: [HttpClient],
        },
      ],
    };
  }
}
